
<mat-spinner *ngIf="!steps[0]"></mat-spinner>
<div class="container" *ngIf="steps[0]">
  <div *ngIf="steps" > <h4>You run the race “{{steps[0].city }}” in  “{{steps[1].city }}” </h4> </div>
    <div class='row'>
      <div class="col md-6">
        <ngb-carousel *ngIf="steps" >
            <ng-template ngbSlide *ngFor='let step of steps'>
              <div class="picsum-img-wrapper">
                <img [src]="step.img" width="100%"  alt="Random third slide">
              </div>
              <div class="carousel-caption" >
                <div class="rounded" style="color: #000; background-color: rgba(255, 255, 255, 0.8);">
                  <h5 style="display: inline;">{{ step.city }}</h5>
                  <ngb-progressbar *ngIf="step.percentage > 0" type="success" [value]="step.percentage"> {{ step.percentage }} %</ngb-progressbar>
                </div>
              </div>
            </ng-template>
        </ngb-carousel>
      </div>
    </div>
  </div>